import PropTypes from 'prop-types';
import Publisher from '../../common/Publisher';

export const appStateShape = PropTypes.shape({
    isLoadingCountries: PropTypes.bool,
    hasError: PropTypes.bool,
    countries: PropTypes.array,
});

const initialState = {
    isLoadingCountries: true,
    hasError: false,
    countries: [],
};

export default class AppStore extends Publisher {
    constructor(handler) {
        super();
        this.handler = handler;
        this.currentState = initialState;

        this.getCountries();
    }

    getCountries = () => this.handler
        .getCountries()
        .then((countries) => {
            this.setState({ countries, isLoadingCountries: false });
        })
        .catch(() => {
            this.setState({ hasError: true });
        });
}



// WEBPACK FOOTER //
// ./src/frontend/apps/VaccinationTool/AppStore.js